import { ResforRepository } from '@/Domain/Resfor/ResforRepository'
import { ResforNif, ResforData, ResforNotFoundError, ResforYear, ResforCode, ResforCommunicationYearNotValidError, ResforPhone, ResforEmail, ResforName } from '@/Domain/Resfor'
import { ProvinceCode } from '@/Domain/Localization/Province'

const storedResforData: { [key: string]: ResforData } = {
  Z6165138Q: new ResforData(
    new ResforCode('not valid'),
    new ResforNif('Z6165138Q'),
    new ResforYear('1970'),
    new ResforName('Madeiras Alfonso')
  ),
  P0552039J: new ResforData(
    new ResforCode('company-resfor-code'),
    new ResforNif('P0552039J'),
    new ResforYear('2020'),
    new ResforName('Madeira Manolo')
  ),
  '10359490Z': new ResforData(
    new ResforCode('a-single-code'),
    new ResforNif('10359490Z'),
    new ResforYear('2019'),
    new ResforName('Andrew Buenafuente'),
    new ResforEmail('one@email.com'),
    new ResforPhone('666666666'),
    null,
    null,
    new ProvinceCode(15),
    null,
    null,
    null,
    null
  )
}
async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}
export class InMemoryResforRepository implements ResforRepository {
  async byNif (resforNif: ResforNif): Promise<ResforData> {
    await wait(400)
    try {
      const foundResfor = storedResforData[resforNif.codeId()]
      if (!foundResfor) {
        throw new ResforNotFoundError('Resfor Nif not found')
      }
      if (foundResfor.lastComunicationYear() < '2000') {
        throw new ResforCommunicationYearNotValidError('Last Communication Year not valid')
      }
      return foundResfor
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
